<template>
    <div class="login_container">
        <HeaderSivoaVue />

        <div class="login_background_image">
            <router-link to="/">
                <img src="./images/WorkshopsCycle3/accueil.svg" alt="classe" height="20px" width="68px" />
            </router-link>

            <div class="w3-row" style="margin-top: 30px; margin-bottom: 130px;">
                <div class="w3-cell w3-cell-middle"><img src="./images/Home/danger.png" alt="danger" /></div>
                <div class="w3-cell w3-cell-middle w3-container">
                    <div class="login_menu_warning">ESPACE R&Eacute;SERV&Eacute;</div>
                    <div class="login_menu_warning">AU SYNDICAT DE L'ORGE</div>
                </div>
            </div>
            <div class="w3-mobile" style="width: 40%;">
                <input id="login" class="w3-input w3-round-medium w3-border w3-margin-bottom login_textbox_font" v-model="login" placeholder="Login">
                <input type="password" id="password" class="w3-input w3-round-medium w3-border w3-margin-bottom login_textbox_font" v-model="password" placeholder="">
                <button class="w3-btn w3-block w3-mobile w3-round-large w3-xlarge w3-ripple login_button" v-on:click="submitWithCaptcha()">VALIDER</button>
                <p>{{ error_message }} </p>
            </div>

            <div style="height: 25px"></div>
        </div>

        <div v-if="debug==1">
            <p>login: {{ login }} </p>
            <p>password: {{ password }} </p>
        </div>

        <vue-programmatic-invisible-google-recaptcha ref="invisibleRecaptcha1"
                                                     :sitekey="'6LelM7UUAAAAABrw5GqPXvDJby9bW37zMmlGahLq'"
                                                     :elementId="'invisibleRecaptcha1'"
                                                     :badgePosition="'left'"
                                                     :showBadgeMobile="false"
                                                     :showBadgeDesktop="false"
                                                     @recaptcha-callback="trylogin"></vue-programmatic-invisible-google-recaptcha>

        <FooterSivoaVue />
    </div>



</template>


<script>
    import HeaderSivoaVue from './HeaderSivoa.vue';
    import FooterSivoaVue from './FooterSivoa.vue';
    import axios from 'axios';

    export default {
        name: 'login_vue',
        data() {
            return {
                debug: 0,
                login: '',
                password: '',
                error_message: '',
                returned_data: '',
                returned_status: '',
            }
        },
        methods: {
            submitWithCaptcha() {
                if (this.login != "" && this.password != "") {
                    this.$refs.invisibleRecaptcha1.execute();
                }
                else {
                    this.error_message = "Veuillez saisir votre login et mot de passe";
                }
            },
            trylogin(recaptchaToken) {
                var json_data = {
                    login: this.login,
                    password: this.password,
                    token: recaptchaToken,
                };

                try {
                    axios({
                        method: "POST",
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        url: 'php/sivoalogin.php',
                        data: json_data,
                    })
                        .then((response) => {
                            //this.returned_data = response.data;
                            //this.returned_status = response.status;

                            if (response.data.code == '200' && response.data.message == 'login ok') {
                                var mytoken = btoa(this.login + '|' + this.password);
                                this.$store.commit("setAuthentication", { status: true, token: mytoken } );

                                if (this.$store.state.config.websiteProtection === true) {
                                    this.$router.push({ name: "home" });
                                } else {
                                    this.$router.push({ name: "management" });
                                }
                            }
                            else {
                                this.error_message = "Login ou mot de passe invalide";
                            }
                        }).catch ((error) => {
                            //console.log(error);
                            this.error_message = "Login ou mot de passe invalide" + error;

                        })
                }
                catch (err) {
                    this.error_message = err;
                }
                    
                //if (this.login == "admin" && this.password == "admin") {
                //    this.$store.commit("setAuthentication", true);
                //    this.$router.replace({ name: "management" });
                //} else {
                //    this.error_message = "Login ou mot de passe invalide"
                //}
            },
        },
        components: {
            HeaderSivoaVue,
            FooterSivoaVue
        },
        computed: {
        },
    };

</script>

<style scoped>
    a {
        text-decoration: none;
    }

    .login_container {
        padding-left: 37px;
        padding-right: 37px;
    }

    .login_background_image {
        width: 100%;
        height: auto;
        background-image: url('./images/Home/bulle.png');
        background-size: cover;
        background-repeat: no-repeat;
        background-color: #C5DCF3;
        padding-left: 37px;
        padding-right: 37px;
    }

    .login_menu_warning {
        font-family: Arial;
        font-size: 16px;
        text-transform: uppercase;
        color: #009AA3;
    }

    .login_textbox_font {
        font-family: Arial;
        font-size: 12px;
    }

    .login_button {
        font-family: 'Roboto Condensed', sans-serif;
        font-style: normal;
        color: #FFFFFF;
        outline: 0;
        background: #6C382A;
    }

</style>